import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; // optional for styling


class TooltipComponent {

	constructor(element, text) {
		const content = text.replaceAll("\n", "<br>");

		this.instance = tippy(element, {
			content : content,
			arrow : true,
			trigger : "click mouseenter focus"
		});
	}

	setText(text) {
		this.instance.setContent(text);
	}
	
}

const tooltip = (element, text) => {
	return new TooltipComponent(element, text);
}

export {
	tooltip
};